import React from "react"

import { Body } from "../ui/Typography/Typography"
import errorIcon from "./assets/error.svg"

// eslint-disable-next-line css-modules/no-unused-class
import css from "./ErrorMessage.module.scss"

interface PropTypes {
  error: string
}
const ErrorMessage = ({ error, ...rest }: PropTypes) => {
  return (
    <div className={css.error}>
      <img loading="lazy" src={errorIcon} alt="" className={css.errorIcon} />
      <Body color="original" variant="body3">
        {error}
      </Body>
    </div>
  )
}

export default ErrorMessage
